/**
 * Created by long on 17-2-13.
 *
 * 删除部分废弃代码 以及整理归档 后续这边不能随便添加方法 需要添加方法
 * 后面这里只是处理基础公用的方法 不做其他额外处理
 * 转移filter配置至src/filter
 */
import { NativeService } from '@/service/native/nativePluginService';
import { getH5Platform, getQueryString, isPC } from '@/utils/environment';
import axios from 'axios';
import config from 'config';
import Vue from 'vue';
import store from '../vuex/index';
import loginInfo from 'config-login-info';
import { dateFormat, getDateInstance, getDateStamp } from 'utils/indexV2';
import NotificationService from 'service/notification';
import { getShowFormatStr } from 'src/i18n/format-show-time';
import { getSplitAppCodeList } from 'views/notification/quick-menu.process';
// eslint-disable-next-line no-unused-vars
import { hlyRouter } from 'utils/routerTools';

Vue.prototype.$http = axios;

let loginType = getQueryString('loginType');
let clientNameMap = {
  dd: 'helios-dd',
  wx: 'helios-wx',
  wxmp: 'helios-wxfw',
  feishu: 'helios-feishu',
  yzj: 'helios-yzj',
  webapp: 'helios-webapp',
  welink: 'helios-welink',
};
let clientName = clientNameMap[loginType] || 'helios-app';

// let config = process.env.config
// 微信修改服务器
//这段加v1的逻辑已经废弃，移动到environment.js getBaseUrl里面了
let { baseWechatServer = '', baseDingtalkServer = '' } = config;
Vue.prototype.baseUrl = config.baseUrl;
// 微信修改服务器
let H5Platform = getH5Platform();
if (H5Platform === 'wx' && baseWechatServer && window.location.href.indexOf('wechat-tc.huilianyi.com') === -1) {
  Vue.prototype.baseUrl += baseWechatServer;
  //axios.defaults.headers.common['corpid'] = corpId || companyOID
  axios.defaults.headers.common['x-helios-client'] = clientName;
} else if (H5Platform === 'dd' && baseDingtalkServer) {
  // 钉钉修改服务器
  Vue.prototype.baseUrl += baseDingtalkServer;
  //axios.defaults.headers.common['corpid'] = corpId
  axios.defaults.headers.common['x-helios-client'] = clientName;
} else if (H5Platform === 'webapp') {
  Vue.prototype.baseUrl += '/v1';
  axios.defaults.headers.common['x-helios-client'] = clientName;
}

if (['feishu', 'welink', 'yzj'].includes(loginType)) {
  axios.defaults.headers.common['x-helios-client'] = clientName;
}

Vue.prototype.environment = config.environment;
Vue.prototype.baseFlyBackUrl = config.baseFlyBackUrl;
Vue.prototype.supplierUrl = config.supplierUrl;
Vue.prototype.JingDongURL = config.JingDongURL;
Vue.prototype.httpHeader = config.httpHeader;
Vue.prototype.electronicImportFlag = config.electronicImportFlag;
Vue.prototype.invoiceVerifyFlag = config.invoiceVerifyFlag;
Vue.prototype.isNewTravel = config.isNewTravel;
Vue.prototype.userName = loginInfo.userName;
Vue.prototype.password = loginInfo.password;
if (config.userName != null) {
  Vue.prototype.userName = config.userName;
  Vue.prototype.password = config.password;
}

Vue.prototype.envConfig = config;

function nativeClose() {
  let loginType = getQueryString('loginType');
  let approveEventUrl = getQueryString('approveEventUrl');

  if (loginType === 'sso' && approveEventUrl) {
    window.location.href = decodeURIComponent(approveEventUrl);
  } else {
    NativeService().closeWindow();
  }
}

const splitAppCodeList = getSplitAppCodeList();

const approvalCallbackTenantIdList = [
  //银座测试
  '1536993190756745218',
  //银座prod
  '1554299698406236162',
];

window.hlyCommon = {
  go(n, doHashChange) {
    let loginType = getQueryString('loginType');
    // 在审批时 飞书的go-1 关不了窗口 所以 在这儿做了判断   满足是 飞书 url 有 messageType
    // messageType 代表消息, 微信钉钉飞书等消息审批/驳回完，统一关闭页面
    //alert(getQueryString('messageType'));
    //alert(getQueryString('loginType'));
    if (!!getQueryString('messageType') && ['feishu', 'wx', 'yzj'].indexOf(loginType) > -1) {
      if (splitAppCodeList.indexOf(getQueryString('messageType')) > -1) {
        //拆子应用场景下不需要关闭页面
      } else {
        // 消息类需要判断是否最后一个页面，需测试
        // issue-163480 【运维-微众】待办进去报销单页面后，编辑行程和补贴保存时自动返回到待办页面
        // issue-153945 【交付-喜马拉雅】保存费用时界面闪退
        /*
        if (!hlyRouter.hasVirtualGoBack()) {
          NativeService().closeWindow();
          return;
        }
        */
        NativeService().closeWindow();
        return;
      }
    }

    //钉钉pc端消息，钉钉pc端待办的路由不按常理出牌，有点太深，history.length 可能不等于 1
    if (getQueryString('targetParams') && isPC() && ['dd'].indexOf(loginType) > -1) {
      NativeService().closeWindow();
      return;
    }

    let oldHref = window.location.href;
    let myInfo = store.getters.getMyInfo;
    let tenantId = myInfo && myInfo.tenantId;
    //代办消息
    let extraParamsEntry = NotificationService.getExtraParamsInSSOLoginType('entry');
    let webAppApprovalCallbackUrl = Vue.prototype.COMMON.getOption('thirdPartyOption.webAppApprovalCallbackUrl');
    if (
      loginType === 'sso' &&
      (window.history.length === 1 ||
        webAppApprovalCallbackUrl ||
        extraParamsEntry === 'customMessgeUrl' ||
        approvalCallbackTenantIdList.indexOf(tenantId) > -1)
    ) {
      let myProfileV2 = store.getters.getMyProfileV2;
      NotificationService.closePageBySsoMode(myInfo, myProfileV2);
      return;
    }
    // 当n < -1时，需要递归调用自身，并设置doHashChange为真
    if (n <= -1) {
      if (n === -1) {
        if (!doHashChange) {
          // 表示未曾递归调用自身，hash值即时改变
          if (window.location.hash === '#/') {
            //NativeService().closeWindow();
            nativeClose();
          } else {
            window.history.go(-1);
          }
        } else {
          // 当go(n < -1)时，会递归调用，导致hash不会立刻改变，所以需要为hash改变加上监听
          let oldHashChange = window.onhashchange;
          window.onhashchange = function () {
            oldHashChange && oldHashChange();
            if (window.location.hash === '#/') {
              //NativeService().closeWindow();
              nativeClose();
            } else {
              window.onhashchange = oldHashChange;
              window.history.go(-1);
            }
          };
        }
      } else {
        window.history.go(-1);
        window.hlyCommon.go(n + 1, true);
      }
    } else {
      window.history.go(n);
    }
    window.closeAppTimeout && clearTimeout(window.closeAppTimeout);
    window.closeAppTimeout = setTimeout(() => {
      let currentHref = window.location.href;

      if (currentHref === oldHref) {
        NativeService().closeWindow();
      }
    }, 100);
  },
};

let targetHash = getQueryString('hash');
store.commit('setTargetHash', targetHash);

Vue.prototype.formatDate = function (time, flag) {
  let date = new Date(time);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let H = date.getHours();
  let f = date.getMinutes();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  H = H < 10 ? '0' + H : H + '';
  f = f < 10 ? '0' + f : f + '';
  if (flag) {
    return y + '-' + m + '-' + d;
  } else return y + '-' + m + '-' + d + ' ' + H + ':' + f;
};

function addSplit(str) {
  let tempArr = str.split('');
  if (tempArr.indexOf('e') != -1) return str;
  let hasMus = tempArr.indexOf('-') != -1 ? 1 : 0;
  let flag = 1;
  for (let i = tempArr.length - 1; i >= 0; i--) {
    if (flag % 3 == 0 && i > hasMus && flag != 3) {
      tempArr.splice(i, 0, ',');
    }
    flag++;
  }
  return tempArr.join('');
}

function numberToAmount(value, type) {
  let precision = Vue.prototype.COMMON.getAccuracy(type);
  return addSplit(
    Number(value) > 100000000000 ? Number(value).toExponential(precision) : Number(value).toFixed(precision)
  );
}

Vue.prototype.currencyFilter = (value, type = '$', noType) =>
  (!noType ? type + ' ' : '') + numberToAmount(value, 'CNY');
//借款金额不显示本位币
Vue.prototype.currencyFilterLoan = (value, type = 'CNY') => numberToAmount(value, type);
// yyyy-MM-dd hh:mm:ss.S
if (!Date.prototype.Format) {
  Date.prototype.Format = function (fmt) {
    let o = {
      'M+': this.getMonth() + 1, //月份
      'd+': this.getDate(), //日
      'h+': this.getHours(), //小时
      'm+': this.getMinutes(), //分
      's+': this.getSeconds(), //秒
      'q+': Math.floor((this.getMonth() + 3) / 3), //季度
      S: this.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp('(' + k + ')').test(fmt))
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
  };
}
String.prototype.replaceAll =
  String.prototype.replaceAll ||
  function (str, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }
    // If a string
    let strAry = str.split('.');
    str = strAry.join('\\.');
    return this.replace(new RegExp(str, 'g'), newStr);
  };

Vue.prototype.formatMoney = function (amount, places, symbol, thousand, decimal) {
  let baseCurrencycode;
  if (store.getters.getCompanyConfigurations) {
    baseCurrencycode = store.getters.getCompanyConfigurations.baseCurrency;
  }
  places = !isNaN((places = Math.abs(places))) ? places : 2;
  places = symbol ? this.COMMON.getAccuracy(symbol) : places;
  symbol = symbol !== undefined ? symbol : baseCurrencycode;
  thousand = thousand || ',';
  decimal = decimal || '.';
  try {
    parseInt(amount);
  } catch (e) {
    return symbol + '0.01';
  }
  let number = amount,
    negative = number < 0 ? '-' : '',
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
    j = i.length > 3 ? i.length % 3 : 0;
  return (
    symbol +
    ' ' +
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    (places
      ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
      : '')
  );
};
Vue.prototype.formatProportion = function (number, decimal = 2, promotion = 100) {
  if (typeof number === 'number' || typeof number === 'string') {
    var f = parseFloat(number);
    if (isNaN(f)) {
      return '';
    }
    var f = Math.round(number * Math.pow(10, decimal) * promotion) / Math.pow(10, decimal);
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + decimal) {
      s += '0';
    }
    return `${s}%`;
  }
  return '';
};

/*
 * 获取格式化的本地日期对象字符串 2017-09-21 23:50:50
 *
 */
Vue.prototype.formatDataByString = function (dateString, format) {
  let formatDesc = 'yyyy-MM-dd';
  if (format) {
    formatDesc = format;
  }
  try {
    let data = new Date(dateString.replace(/-/g, '/'));
    return data.Format(formatDesc);
  } catch (e) {
    return dateString;
  }
};

//获取格式化的本地日期对象字符串
Vue.prototype.formatLocalData = function (utc, format) {
  let formatDesc = 'yyyy-MM-dd';
  if (format) {
    formatDesc = format;
  }
  try {
    let data = new Date(utc);
    return data.Format(formatDesc);
  } catch (e) {
    return utc;
  }
};

//获取格式化的本地星期描述
Vue.prototype.formatWeekDesc = function (utc) {
  let flag = '';
  switch (new Date(utc).getDay()) {
    case 0:
      flag = window.$t('other-1.key28', { cm: '周日' });
      break;
    case 1:
      flag = window.$t('other-1.key29', { cm: '周一' });
      break;
    case 2:
      flag = window.$t('other-1.key30', { cm: '周二' });
      break;
    case 3:
      flag = window.$t('other-1.key31', { cm: '周三' });
      break;
    case 4:
      flag = window.$t('other-1.key32', { cm: '周四' });
      break;
    case 5:
      flag = window.$t('other-1.key33', { cm: '周五' });
      break;
    case 6:
      flag = window.$t('other-1.key34', { cm: '周六' });
      break;
  }
  return flag;
};

// 检测 ios 11.2 版本，如果是ios 11.2 使用 animation代替 transition
let isIOS112 = false;
// let isIOS8 = false;
let appVersion = window.navigator.appVersion;
if (appVersion.match(/OS 11_2_6.*(Mac OS X)/)) {
  isIOS112 = true;
}
// else if (appVersion.match(/OS 8.*(Mac OS X)/)) {
//   isIOS8 = true;
// }

Vue.prototype.transName = (name) => {
  //
  if (isIOS112) {
    return `ios-${name}`;
    // }else if(isIOS8){
    //     return ''
  }
  return name;
};
/**
 * Created by zt on 2019/01/25.
 * 公用函数
 *
 * 处理大部分业务场景 后续有需求可自行更新或提需求我来处理
 * 要求： 写好注释(函数目的，解决场景(部分即可), 使用案例)
 *
 */

Vue.prototype.COMMON = {
  /**
   * 页面金额显示
   * eg this.COMMON.displayAmount(55, 'CNY');
   * 废弃 使用formatMoney
   * @param currencyCode
   * @param amount
   * @returns {*|void|string}
   */
  displayAmount(amount, currencyCode) {
    if (isNaN(+amount)) {
      return amount;
    }
    return (+amount).toFixed(this.getAccuracy(currencyCode));
  },
  /**
   * 获取精确度
   * eg this.COMMON.getAccuracy('CNY');
   * @param currencyCode
   * @returns {number}
   */
  getAccuracy(currencyCode) {
    let code = currencyCode;
    if (!currencyCode) {
      code = store.getters.getCompanyConfigurations.baseCurrency;
    }
    let allCurrency = store.getters.getAllCurrency || [];
    let currentCurrency = allCurrency.find((item) => item.currencyCode === code);
    return !currentCurrency ? 2 : currentCurrency.precision;
  },
  /**
   * 获取后端接口返回错误信息
   * eg this.COMMON.getErrorMessage(error)
   * @param error fetch接口错误返回对象
   * @param defaultMessage 默认错误文案
   * */
  getErrorMessage(error, defaultMessage = window.$t('other-1.key35', { cm: '请求超时，请稍后再试试吧' })) {
    let message = defaultMessage;
    let currentMessage = this.getValue(error, 'response.data.message');
    if (currentMessage) {
      const rets = [currentMessage];
      const spanid = this.getValue(error, 'response.headers.spanid');
      const errorCode = this.getValue(error, 'response.data.errorCode');
      if (spanid && errorCode === 'SYSTEM_EXCEPTION') {
        rets.push(window.$t('other-1.key51', { arg1: spanid, cm: '错误编码：{arg1}' }));
      }
      message = rets.join(', ');
    }
    if (this.getValue(error, 'status') === -1009 || this.getValue(error, 'message') === 'Network Error') {
      // 断网的情况
      message = window.$t('other-1.key36', { cm: '网络不给力，请稍后再试试吧' }); //网络不给力，请稍后再试试吧
    }
    return message;
  },
  /**
   * 公用错误处理 提示2s的接口返回错误信息
   * eg this.COMMON.errorHandle(error)
   *
   * 支持弹窗错误提示
   *
   * @param error fetch接口错误返回对象
   * @param defaultMessage 默认错误文案
   * */
  errorHandle(error, defaultMessage = window.$t('other-1.key35', { cm: '请求超时，请稍后再试试吧' })) {
    if (this.getValue(error, 'isCancel')) {
      return;
    }
    const { needConfirm, confirmTitle } = this.getValue(error, 'response.data', {});
    let errorText = this.getErrorMessage(error, defaultMessage);
    if (needConfirm) {
      Vue.$handPlugin.confirm.show({
        textStyle: {
          'max-height': '2.8rem',
          'font-size': '0.15rem',
          'line-height': '.2rem',
          overflow: 'auto',
          'text-align': 'center',
          'margin-bottom': '.25rem',
          'white-space': 'pre-wrap',
        },
        title: confirmTitle,
        content: errorText,
      });
      return !1;
    }
    Vue.$handPlugin.toast.show({
      text: errorText,
      time: 2000,
    });
  },
  /**
   * 数组相等比较
   * 后续可扩展对象比较 目前没有用到所以先不处理
   *
   * 添加传入值安全处理
   * eg this.COMMON.isEqualArray(userDTOList1,userDTOList2,'userOID')
   * @param arr1 待比较数组
   * @param arr2 待比较数组
   * @param key  比较key
   * */
  isEqualArray(arr1, arr2, key) {
    !Array.isArray(arr1) && (arr1 = []);
    !Array.isArray(arr2) && (arr2 = []);
    if (arr1.length !== arr2.length) {
      return false;
    }
    return arr1.every((item) => !!arr2.find((item2) => item2[key] === item[key]));
  },
  /**
   * 标题设置成上一次记录
   * 使用popup时需要修改title 关闭时需要把title修改为原来默认的
   */
  setPrevTitle() {
    NativeService()
      .getLocalStorageItem('title')
      .then((res) => {
        NativeService().setTitle(res, false);
      });
  },
  /**
   * 获取当前对象的值 解决空指针处理
   * 处理场景 if(a && a.b && a.b.c) {}
   * 有值则返回对应信息 没有则返回null
   * getCurrentObjValue => getValue 名称修改 名称过长
   * eg this.COMMON.getValue(error, 'response.data.message')
   * @param obj 数据对象 Object
   * @param keyRoute key指路径信息 [String, Array]
   */
  getValue(obj, keyRoute, defaultValue = undefined) {
    let result = obj;
    const keyArr = Array.isArray(keyRoute) ? keyRoute : keyRoute.split('.');
    try {
      keyArr.forEach((item) => {
        result = result[item];
      });
    } catch (e) {
      result = undefined;
    }
    if (result === undefined) {
      result = defaultValue;
    }
    return result;
  },
  /**
   * 获取用户option配置中得值
   * 基于getValue做的特殊处理
   * eg this.COMMON.getOption('auditBaseConfig.rejectWithCondition')
   * @param keys string 'auditBaseConfig.rejectWithCondition'
   * @returns {null|any}
   */
  getOption(keys) {
    let option = store.getters.getOptions || {};
    return this.getValue(option, keys);
  },
  getCurrentTimeZoneOffset() {
    return getDateInstance().getTimezoneOffset();
  },
  handleTimeWidthZoneOffset(date, timeZoneOffset, formatStr = 'yyyy-MM-dd') {
    if (!date) {
      return date;
    }
    let currentTimeZoneOffset = -this.getCurrentTimeZoneOffset();
    let times = getDateStamp(date);
    if (timeZoneOffset && currentTimeZoneOffset !== timeZoneOffset) {
      times += (timeZoneOffset - currentTimeZoneOffset) * 60 * 1000;
    }
    return dateFormat(times, formatStr);
  },
  /**
   * 版本限制 版本比较需要额外处理
   * eg this.COMMON.versionEnable('2.12.0')
   *
   * 修正 limitVersion: '7.2'  currentVersion: '7.011' 返回结果为true
   * 值添加位数处理 如果版本以0开头则 需要转化成小数对比处理
   *
   * stage环境支持版本控制 默认不控制 传参则需要处理
   *
   * 测试环境可以直接使用
   * @param limitVersion 2.8.0 string
   * @param stageLimitVersion 1.0.18 string stage版本限制
   */
  versionEnable(limitVersion, stageLimitVersion) {
    if (['dev', 'uat', 'sit'].includes(config.env)) {
      return true;
    }
    if (config.env === 'stage') {
      if (!stageLimitVersion) {
        return true;
      }
      limitVersion = stageLimitVersion;
    }
    //版本判断支队长app生效，其他在线平台不需要
    if (getQueryString('loginType') !== 'cd') {
      return true;
    }
    let currentVersion = '' + store.state.version;
    let currentVersionArr = currentVersion.split('.');
    let limitVersionArr = ('' + limitVersion).split('.');

    let result = false;
    for (let i = 0; i < limitVersionArr.length; i++) {
      try {
        let currentVal = +currentVersionArr[i];
        let limitVal = +limitVersionArr[i];
        if (
          ('' + currentVal).length !== currentVersionArr[i].length ||
          ('' + limitVal).length !== limitVersionArr[i].length
        ) {
          currentVal = +('1.' + currentVersionArr[i]);
          limitVal = +('1.' + limitVersionArr[i]);
        }
        if (currentVal > limitVal) {
          result = true;
          break;
        } else if (i === limitVersionArr.length - 1 && currentVal === limitVal) {
          result = true;
        } else if (currentVal < limitVal) {
          result = false;
          break;
        }
      } catch (e) {}
    }
    return result;
  },
  ignoreTimeZone(dateString) {
    if (typeof dateString !== 'string') return dateString;
    if (/.+Z$/.test(dateString)) return dateString.replace('T', ' ').replace(/\-/gm, '/').slice(0, -1); //utc时间格式2020-05-07T23:59:00Z
    return dateString.replace('T', ' ').replace(/\-/gm, '/').split('+')[0]; //本地时间格式 2020-05-07T23:59:00+08:00
  },
  // 获取时差
  // timeZoneOffset：单据保存时区 与 0时区 的时差
  // nowTimeZoneOffset：当前时区 与 0时区 的时差
  // timeOffset：单据保存时区 与 当前时区 的时差
  getTimeOffset(timeZoneOffset) {
    let timeOffset = 0;
    let nowTimeZoneOffset = -new Date().getTimezoneOffset();
    if ((timeZoneOffset || timeZoneOffset === 0) && timeZoneOffset !== nowTimeZoneOffset) {
      timeOffset = timeZoneOffset - nowTimeZoneOffset;
    }
    return timeOffset;
  },
  //处理成GTM +/- HH:mm
  //timeZoneOffset：单据保存时区 与 0时区 的时差
  processTimeOffset(timeZoneOffset) {
    let result = 'GMT';
    let tempOffset = Math.abs(timeZoneOffset);
    let hh = Math.floor(tempOffset / 60)
      .toString()
      .padStart(2, '0');
    let mm = Math.floor(tempOffset % 60)
      .toString()
      .padStart(2, '0');
    let timeStr = `${hh}:${mm}`;
    if (timeZoneOffset >= 0) {
      result += `+${timeStr}`;
    } else {
      result += `-${timeStr}`;
    }
    return result;
  },
  /**
   * 有效多语言 默认支持中英文 后续有需求可支持其他语言
   * 用于处理多语言场景下的图片信息
   * 图片命名需要规划化 eg: xxx-zh.png xxx-en.png xxx-tw.png
   * eg this.COMMON.getCurrentValidLanguage()
   * @param languageList 可使用的语言列表 自定义 默认中英文
   * @returns {string}
   *
   * fixed 不支持当前语言时取支持列表的第一个
   */
  getCurrentValidLanguage(languageList = ['zh', 'en']) {
    let language = store.getters.getSelectedLanguage;
    let lan = 'zh';
    if (language) {
      if (['zh_cn', 'zh'].includes(language)) {
        lan = 'zh';
      } else if (language === 'en') {
        lan = 'en';
      } else if (language === 'zh_TW') {
        lan = 'tw';
      } else if (language === 'ja') {
        lan = 'ja';
      } else {
        lan = 'en';
      }
    }
    if (!languageList.includes(lan)) {
      lan = languageList[0];
    }
    return lan;
  },
  /**
   * 获取多语言图片 图片引导地址统一动态获取
   * 不改变代码或者改动少量代码的情况下 可以加载不同语言环境的介绍说明图片
   * 默认找对应语言的信息 找不到则找中文环境下的图片
   * eg this.COMMON.getCurrentLanguageLogoUrl({sourceUrl: 'scan/logo-pc-scan-view-{lan}.png'})
   *
   * 这个方法回加载所有图片 打包之后图片过大 所以统一将图片放到multi-language文件夹下 后期可以考虑如果图片过大或过多的话 换成cdn资源
   *
   * 多语言图片统一改为cdn在线处理 后续需要添加图片资源统一找顾哥处理
   *
   * @param sourceUrl 图片原地址 需要提供占位符 eg mile/steps/step-instruction-1-{lan}.png
   * @param online 是否在线资源 在线资源则直接替换
   * @param languageList
   * @returns {any}
   */
  getCurrentLanguageLogoUrl({ sourceUrl = '', online = false, languageList = ['zh', 'en'] }) {
    let lan = this.getCurrentValidLanguage(languageList);
    if (online) {
      return sourceUrl.replace('{lan}', lan);
    }
    return `http://cloudhelios-static.oss-cn-shanghai.aliyuncs.com/app-image-cdn/${sourceUrl.replace('{lan}', lan)}`;
  },
  /**
   * 获取对象中的某些属性并返回新的数组 直入直出 比较复杂的额外处理
   * 优化代码 避免重型赋值
   * eg result.name = obj.name;result.id = obj.id;result.title = obj.title;result.toast = obj.toast;
   * eg this.COMMON.getObjByKeys(['name', 'title'], obj);
   * @param keys key数组
   * @param obj source对象
   * @returns {*}
   */
  getObjByKeys(keys, obj) {
    return keys.reduce((result, item) => {
      result[item] = obj[item];
      return result;
    }, {});
  },
  /**
   * 获取子应用菜单(按钮)权限
   * eg this.COMMON.getSubMenuPermission("EXPENSE_CLAIM", "approve");
   * @param appCode 子应用编码 (不重复)
   * @param menuCode 菜单编码(有可能重复)
   * @returns {boolean} true 启用 false不启用
   */
  getSubMenuPermission(appCode, menuCode) {
    const allSubMenuPermission = store.state.allSubMenuPermission || [];
    const currentAppCodeInfo = allSubMenuPermission.find((item) => item.appCode === appCode) || {};
    return (currentAppCodeInfo.widgetSubMenus || []).some((item) => item.widgetSubMenuCode === menuCode);
  },
  /**
   * 子应用是否启用
   * 简单处理 获取所有子应用信息 判断code是否存在
   * eg this.COMMON.getSubAppPermission("MY_DOCUMENT");
   * @param appCode 子应用编码 (不重复)
   * @returns {boolean} true 可用 false不可用
   */
  getSubAppPermission(appCode) {
    const allApp = store.state.allApplicationList || [];
    return allApp.some((item) => (item.sectionDetail || []).some((app) => app.appCode === appCode));
  },
  /**
   * 在线子应用是否启用
   * 简单处理 获取所有子应用信息 判断code是否存在
   * eg this.COMMON.getOnlineAppPermission("TMC_AUTH_MANAGEMENT");
   * @param appCode 子应用编码 (不重复)
   * @returns {boolean} true 可用 false不可用
   */
  getOnlineAppPermission(appCode) {
    const allApp = this.getValue(store.state.mineProfileOnlineApp, 'appList') || [];
    const otherApp = this.getValue(store.state.mineProfileOnlineApp, 'other') || {};
    return (
      !!otherApp[appCode] || allApp.some((item) => (item.sectionDetail || []).some((app) => app.appCode === appCode))
    );
  },
  /**
   * 获取金额单位 业务统一显示
   * eg this.COMMON.getAmountUtil(10000);
   * @param amount
   * @param length 单据过10万才显示 默认万显示
   */
  getAmountUtil(amount, length = 5) {
    let result = '';
    let utilMap = {
      5: '万',
      6: '十万',
      7: '百万',
      8: '千万',
      9: '亿',
      10: '十亿',
      11: '百亿',
      12: '千亿',
      13: '兆',
      14: '十兆',
      15: '百兆',
    };
    if (!isNaN(+amount) && this.getCurrentValidLanguage() === 'zh') {
      let curLength = `${Math.floor(Math.abs(amount))}`.length;
      if (curLength >= length) {
        result = utilMap[`${Math.floor(Math.abs(amount))}`.length] || '';
      }
    }
    return result;
  },
  /**
   * 多语言 时间显示 读取多语言平台配置
   * eg this.COMMON.getShowTime('2020-01-01');
   * @param date 时间
   * @param format 中文格式 默认YYYY-MM-DD
   * @returns {*}
   */
  getShowTime(date, format = 'YYYY-MM-DD') {
    return window.moment(date).format(getShowFormatStr(format));
  },
  /**
   * xss 转化处理
   * @param content String
   * @returns {*}
   */
  $filterXss(content) {
    if (window.filterXSS) {
      // 使用时注入属性
      if (window.filterXSS.whiteList && !window.filterXSS.isHlyProject) {
        Object.keys(window.filterXSS.whiteList).forEach((tagName) => {
          window.filterXSS.whiteList[tagName].push('class', 'style', 'data-*');
        });
        window.filterXSS.isHlyProject = true;
      }
      return window.filterXSS(content);
    }
    return content;
  },
};

//保留两位小数
Vue.prototype.keepTwoNumFilter = (number, decimal) => {
  if (number === '' || number === undefined || number === null) return '';
  if (number.toString() && number.toString().split('.')[1]) {
    if (number.toString().split('.')[1].length < decimal) {
      var i = 0,
        temp = decimal - number.toString().split('.')[1].length,
        zero = '';
      for (i; i < temp; i++) {
        zero += '0';
      }
      return number + zero;
    } else {
      if (number === 0) {
        return number;
      } else {
        return number.toFixed(decimal);
      }
    }
  } else {
    var i = 0,
      zero = '.';
    for (i; i < decimal; i++) {
      zero += '0';
    }
    return number + zero;
  }
};

//获取格式化的本地日期对象字符串
Vue.prototype.formatLocalDataMonth = function (utc, format) {
  let formatDesc = 'MM-dd';
  if (format) {
    formatDesc = format;
  }
  try {
    let data = new Date(utc);
    if (data.toString() === 'Invalid Date') {
      if (typeof utc === 'string') {
        data = new Date(utc.replace(/\-/gm, '/'));
      }
    }
    return data.Format(formatDesc);
  } catch (e) {
    return utc;
  }
};

Vue.prototype.format = function (time, flag) {
  let date = new Date(time);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  if (flag) {
    return y + '-' + m + '-' + d;
  } else return y + '-' + m + '-' + d;
};
